import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import sortBy from 'lodash/sortBy';
import { BIODATAFORMAT } from '../../Constants/Models/bio-data-format';

function getMeasurements(item, measurementsValue) {
  const itemMeasurements = get(item, 'measurements', []);
  if (!itemMeasurements.length) {
    return measurementsValue;
  }
  const measurementsArr = [];

  itemMeasurements.forEach((measurement) => {
    const obj = get(measurement, 'obj');
    if (obj) {
      measurementsArr.push(obj);
    }
  });

  if (measurementsArr.length) {
    return `(${measurementsArr.join(', ')})`;
  }
  return measurementsValue;
}

function getMetabolites(item, metabolitesValue) {
  const itemMetabolites = get(item, 'metabolites', []);
  if (!itemMetabolites.length) {
    return metabolitesValue;
  }
  const metabolites = [];

  itemMetabolites.forEach((metabolite) => {
    const name = get(metabolite, 'name');
    if (name) {
      metabolites.push(name);
    }
  });

  if (metabolites.length) {
    return `${metabolites.join(', ')}`;
  }
  return '';
}

function getConcomitants(item, concomitantsValue) {
  const itemConcomitants = get(item, 'concomitants', []);
  if (!itemConcomitants.length) {
    return concomitantsValue;
  }

  const groupedRoles = {};

  itemConcomitants.forEach((concomitant) => {
    const role = get(concomitant, 'role');
    const name = get(concomitant, 'name');
    if (role && name) {
      if (groupedRoles[role]) {
        groupedRoles[role].push(name);
      } else {
        groupedRoles[role] = [name];
      }
    }
  });

  let value = '';
  Object.keys(groupedRoles).forEach((role) => {
    if (groupedRoles[role].length) {
      value += `${role}: ${groupedRoles[role].join(', ')}${Object.keys(groupedRoles).length > 1 ? ';' : ''} `;
    }
  });

  return value;
}

// eslint-disable-next-line import/prefer-default-export
export const changeQuanDataFormat = (type, quan) => {
  if (!quan || !quan.data) {
    return quan;
  }
  // eslint-disable-next-line no-param-reassign
  type = type.toLowerCase();

  const mockModel = BIODATAFORMAT[type];

  if (!mockModel) {
    Logger.error(`BioDataService: Format '${type}' is not exist.`);
    return {};
  }
  const storage = cloneDeep(mockModel);

  const headers = quan.formatedData ? quan.formatedData.headers : sortBy(storage.headers, 'order');

  // eslint-disable-next-line no-param-reassign,no-return-assign
  headers.forEach((header) => (header.hasContent = false));

  const rows = [];
  quan.data.forEach((item) => {
    const cells = [];
    headers.forEach((header) => {
      const { id, order } = header;

      let value = item.details[id];
      let measurements = '';

      if (id === 'parameter') {
        measurements = getMeasurements(item, measurements);
      }

      if (id === 'metabolites') {
        value = getMetabolites(item, value);
      }

      if (id === 'concomitants') {
        value = getConcomitants(item, value);
      }

      if (value && value.length) {
        // eslint-disable-next-line no-param-reassign
        header.hasContent = true; // Mark for header
      }

      cells.push({ id, order, value, measurements, details: item.details }); // Create new format for cells
    });
    rows.push({ cells });
  });
  // eslint-disable-next-line no-param-reassign
  quan.formatedData = { headers, rows };

  return quan;
};
